import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, getStylesRef, getSize, rem } from '@mantine/styles';
import { THUMB_SIZES } from '../Thumb/Thumb.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var useStyles = createStyles(function (theme, _params, _ref) {
  var size = _ref.size;
  return {
    sliderThumb: {
      ref: getStylesRef("sliderThumb")
    },
    slider: {
      position: "relative",
      height: "calc(".concat(getSize({
        size,
        sizes: THUMB_SIZES
      }), " + ").concat(rem(2), ")"),
      boxSizing: "border-box",
      marginLeft: "calc(".concat(getSize({
        size,
        sizes: THUMB_SIZES
      }), " / 2)"),
      marginRight: "calc(".concat(getSize({
        size,
        sizes: THUMB_SIZES
      }), " / 2)"),
      outline: 0,
      ["&:focus .".concat(getStylesRef("sliderThumb"))]: __spreadValues({}, theme.focusRing === "always" || theme.focusRing === "auto" ? theme.focusRingStyles.styles(theme) : theme.focusRingStyles.resetStyles(theme)),
      ["&:focus:not(:focus-visible) .".concat(getStylesRef("sliderThumb"))]: __spreadValues({}, theme.focusRing === "auto" || theme.focusRing === "never" ? theme.focusRingStyles.resetStyles(theme) : null)
    },
    sliderOverlay: {
      position: "absolute",
      boxSizing: "border-box",
      top: 0,
      bottom: 0,
      left: "calc(".concat(getSize({
        size,
        sizes: THUMB_SIZES
      }), " * -1 / 2 - ").concat(rem(1), ")"),
      right: "calc(".concat(getSize({
        size,
        sizes: THUMB_SIZES
      }), " * -1 / 2 - ").concat(rem(1), ")"),
      borderRadius: 1e3
    }
  };
});
export default useStyles;